export const VERSION = "V3.2.34";

/*
V3.2.33 - Remove import version mismatch warning and export resaved quotes with the current site version.
V3.2.32 - Auto-add Special category/subcategory items when extra_field_4 contains a positive quantity.
V3.2.31 - Fix Camera page drop calculation so cameras with extra_field_2 add to existing camera drops instead of replacing them.
V3.2.30 - Keep Save As CSV export but use quote-number-only CSV filenames.
V3.2.29 - Patch Cart page CSV export to use Save As dialog path and quote/customer filename.
v3.2.27 - Use extra_field_3 for labor drop-quantity defaults, rename the service-call button, and allow auto-added SVC labor quantity edits.
v3.2.26 - Move Labor service-call automation to a calculate-only button by Next, and only default extra_field_4=1 labor to option drops.
v3.2.25 - Fix SVC-Call display by treating extra_field_1/3 as standard fields, and include all extra_field_4=1 labor lines in SVC-Call quantity calculations.
V3.2.24 - Add Labor-page drop-labor automation with LABOR-STD selection and city-based SVC-Call quantity calculation.
V3.2.6 - Fix home packet appended thumbnail sizing, add install-image link, and remove trailing blank page.
V3.2.5 - Append home packet contents after quote when HOME packet is selected using the packet sizing model.
V3.2.4 - Packet cover page sizing fix using percent-based packet layout.
V3.0.0 - Problem with NVR pricing display in cart
V3.0.1 - Fixed NVR Pricing Unit display in cart
v3.0.2 - Fixed issue with Labor warning firing even though it matched
v3,0.3 - Fixed issue with cales displaying cable option 2 times in cart only
v3.0.4 - Fixed issue with returning to Labor page from cart
v3.0.6 - Fixing Labor Warning again
v3.0.7 - Fixing issue where OPTION title was not carrying into print.
v3.0.8 - Fixing Option text in the cart
v3.0.9 - Cosmetic fixes in cart
v3.0.10 - CSS fix for Cart table
v3.0.11 - Add back Cart column description only on top row.
v3.0.12 - Widen Description Column on Cart Page 
v3.0.13 - Fix for issue with NVRs displaying the base cost instead of modified cost.
v3.0.14 - Fix for issue with cable options displaying 2 times
v3.1.2 - Restrict automatic starter Special items to standard Build Quote only; make linked service labor fallback-detect NVRs/enclosures and hide extra_field_5.
v3.1.3 - Disable automatic SVC-Server and SVC-ENC linked labor for Dealer quotes.
v3.1.5 - Restored Cart export/import version metadata and mismatch warning.
v3.1.6 - Restore visible quote version display on Cart/Print and add version monitoring to Home import.
v3.1.6T - New Test build based on 3.1.6
v3.1.13 - Standardize option-product unit cost editing so editable field controls base price while option adders remain separate.
v3.1.14 - Standardize NVR option pricing and always show Special option cost line.
v3.1.8 - Preserve custom item pricing through cart export/import and print.
v3.1.10 - Restore Add/Remove option controls in Cart; relocate controls below editor near option copy buttons.
v3.1.12 - Fix product flyout manual Unit Cost typing so cents and multi-digit prices can be entered cleanly.
v3.1.11 - Add initial Home-page option title/subtitle defaults for new quotes with 2+ options.
v3.1.15 - Use site-root logo URL in Cart/Print and add per-option discount before totals.
v3.1.16 - On import, compare exported pricing to current CSV pricing and update imported cart after alert.
v3.1.17 - Add import pricing review dialog with per-line Imported vs Current choices.
v3.1.18 - Align import price comparison with product flyout sale pricing and rename Current Pricing column.
v3.1.19 - Fix Cameras edit flyout to display base price plus selected option price before updating cart.
v3.1.20 - Group import pricing review by option and force Cameras edit flyout live total to include selected options.
v3.1.22 - Prevent non-option items like ADDIPs from inheriting option-price adjustments during import price refresh.
v3.1.21 - Import pricing review removes duplicate option column and Home import restores per-option discounts.
v3.1.23 - Import pricing review compares and applies base and selected option pricing separately.
v3.2.0 - Rebuild Build Packet workflow on stable v3.1.23 import/pricing architecture.
v3.2.1 - Fix Build Packet cover prepend for HashRouter print route and allow cover assets to load before print.
v3.2.2 - Isolate packet cover CSS from quote print CSS, refresh packet-html assets, and hide internal unitPrice fields from option display.
v3.2.3 - Fix packet cover asset/font paths to use PUBLIC_URL and keep packet HTML only under public/packet-html.
V3.2.8 - Packet image class cleanup and page break before appended packet.
v3.2.10 - Updated CSS for images
v3.2.11 - Updated CSS for images in packet - wrapping entire packet for better control in a div ID
v3.2.12 - Moved CSS for packets into page to try to avoid print.js rewriting
v3.2.15 - Adjusting inline formatting
v3.2.18 - Adjusted the inline CSS to match packet design manually.
v3.2.19 - Moved all CSS from the packet into the index.css file and tested.
v3.2.20 - Update packet Chanson font filename to chalbi.woff2 and wait for fonts before printing.
v3.2.21 - Convert packet cover page text layout from absolute positioning to margin-based flow.
v3.2.22 - Consolidate packet heading, feature, float, icon, and image CSS for business/home packet HTML cleanup.
v3.2.23 - Wait for rendered packet images and fonts before opening the print dialog.
v3.2.28 - Add Save As CSV export support and customer-based quote/packet print filenames.
v3.2.29 - Added SaveAs for Chromium browsers - will only work on SSL or local sites
v3.2.30 - Changed to have CSV still just named the same as the quote #
v3.2.31 - Cleaned up support for Cameras with 2 drops (extra_field_2 = 2)
v3.2.32 - Changed so setting extra_field_4=1 for any items in special categories would add to cart on new quote creation
v3.2.33 - Removed warning when importing quote, depreciated for newer price comparison. - adjusted so it will save the version to csv on re-save
v3.2.34 - Moved images from packet to root folder
*/
export const LEGACY_VERSION_LABEL = "Legacy / unknown";
export const normalizeVersion = (value) => {
  return String(value || "")
    .trim()
    .replace(/^version\s*/i, "")
    .replace(/^v/i, "")
    .toLowerCase();
};

export const isLegacyVersion = (quoteVersion) => {
  const value = String(quoteVersion || "").trim();
  return value === LEGACY_VERSION_LABEL;
};

export const isVersionMismatch = (quoteVersion, appVersion = VERSION) => {
  if (!quoteVersion) return false;
  if (isLegacyVersion(quoteVersion)) return true;
  return normalizeVersion(quoteVersion) !== normalizeVersion(appVersion);
};

export const getVersionWarningMessage = (quoteVersion, appVersion = VERSION) => {
  if (!isVersionMismatch(quoteVersion, appVersion)) return "";
  const shownVersion = quoteVersion || LEGACY_VERSION_LABEL;
  return `This quote was created/exported with ${shownVersion}, but the current site is ${appVersion}. Please review pricing before using this quote.`;
};

export default VERSION;
